var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 266.6 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .color0, .color1, .color2, .color3, .color4, .color5, .color6, .color7, .color8, .color9, .color10, .color11 {\n      stroke: #333;\n      stroke-width: 2;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      stroke-opacity: .1;\n      }\n\n      .color0:hover, .color1:hover, .color2:hover, .color3:hover, .color4:hover, .color5:hover, .color6:hover, .color7:hover, .color8:hover,\n      .color9:hover, .color10:hover, .color11:hover {\n      fill: #ffff66; /* Change fill color on hover */\n      stroke: black; /* Change stroke color on hover */\n      stroke-width: 1;\n      stroke-opacity: 1;\n      }\n\n      .highlight, .highlight:hover {\n      fill: #ff0000 !important;\n      }\n\n      .color0 {\n      fill: #ffffcc;\n      }\n\n      .color1 {\n      fill: #ccffcc;\n      }\n\n      .color2 {\n      fill: #ccb0ff;\n      }\n\n      .color3 {\n      fill: #ffcc99;\n      }\n\n      .color4 {\n      fill: #ccccff;\n      }\n\n      .color5 {\n      fill: #ccff99;\n      }\n\n      .color6 {\n      fill: #ffcccc;\n      }\n\n      .color7 {\n      fill: #99ccff;\n      }\n\n      .color8 {\n      fill: #ffeecc;\n      }\n\n      .color9 {\n      fill: #ffffe0;\n      }\n\n      .color10 {\n      fill: #ffccff;\n      }\n\n      .color11 {\n      fill: #99ffcc;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cc_dz",
    className: "color3",
    d: "M95.4,32.3l-5.6-1.9-23.4,4.4-5.1,3.9,3.1,16.1-9.3.4-5.6,9-13.3,3.2v6.5s43.9,33.5,43.9,33.5l7.5.6,24.9-19.5-2.5-3.1-4.7-.6-2.8-4.7v-19.5l-1.9-1.9.3-5-5-5-.6-5.3,2.2-1.6-.9-5.7-1.2-3.7h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ma",
    className: "color7",
    d: "M60.2,38.9h-15.9l-3.1,6.9-7.2,3.5-5.9,16-11.5,6.9L.3,99l15.9-.3.6-7.9h4.1v-10.7h14l.3-13.8,13.4-3.1,5.6-9.1,8.7-.3-2.8-14.8h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "cc_mr",
    className: "color2",
    d: "M.4,100.1l3,3.9-.6,17,4.4-3.1,3.1-.6,4.4,1.6,5,6.9,4.7-3.1,22.8-.3-5.6-38h6s-11.2-8.6-11.2-8.6v5.6s-14.2,0-14.2,0v10.7c0,0-4.2,0-4.2,0l-.5,7.9-16.9.4H.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "cc_sn",
    className: "color6",
    d: "M10.2,118.2l-2.6.6-5.4,4-1.2,2.2-.4,2.2,2,1.4h6.7c0,0,4.3-1.2,4.3-1.2l.5,2.1-.4,2.8h0s-10.7.2-10.7.2l1.7,4.1.9-2.5,12.8,1.1h0c0,0,1.3.1,1.3.1l4.1.2.2-2.4-4.9-5.9-5.5-7.5-3.4-1.4h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "cc_gm",
    className: "color3",
    d: "M3.1,129.9l-.2,1.5h9.5c0-.1.5-1.6.5-1.6l-.2-1.4-2.7,1.1-6.9.3h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "cc_gw",
    className: "color8",
    d: "M5.5,138.5l1.9,3.8,5.4-4.7v-1.4c0,0-6.3-.9-6.3-.9l-1,3.2h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "cc_gn",
    className: "color7",
    d: "M8,143.2l4.2,6.4,5.5-4.7,5.6-.2,4.7,6.2,4,2.6,1.5-2.9,1.3-.7v-6.4c0,0-2.7-7.5-2.7-7.5l-8.1.9-10-.8v2.6c0,0-5.9,4.6-5.9,4.6h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "cc_sl",
    className: "color0",
    d: "M12.8,150.3l7.8,7.5,5.6-6.7-3.5-5.4-4.8.5-5.1,4.2h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "cc_lr",
    className: "color5",
    d: "M21.4,158.7l15.1,10.1-.4-7.7-4.6-5.4-4.5-4-5.7,6.9h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ci",
    className: "color3",
    d: "M37.8,169.1l5.9-4.2,7.3-1.3,7.5,1.6-3.8-5.8-1.1-3.5,1.1-10.4-6.7.3-3-2.9-6.4.2-3,.5.3,7.1-1.6.6-1.9,3.5,4.9,5.8.5,8.5h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ml",
    className: "color5",
    d: "M20.5,126.5l4.2-2.9h23.6c0-.1-5.5-38.1-5.5-38.1l6.2-.2,30.1,23,4.1.6-1.5,12.8-18.9,1.7-14.6,10.9-2.7,7.5-10.2.4-2.6-7.5-7.8.6.3-2.4-4.8-6.4h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "cc_bf",
    className: "color0",
    d: "M63.3,124.3l5-.4,8.2,11.6-7.6,5.8-5.5-1.4h-7.4c0,0-1.2,4.4-1.2,4.4l-6.2.3-1.7-2.3,2.2-7.1,14.3-10.9h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ne",
    className: "color6",
    d: "M77.5,135h3.5c0,0,3.2-4.8,3.2-4.8l5.3-1,5.7,3.5,12.1.3,9.3-3.8,3.5-3,.3-4,6.5-6.6,1.7-14.5-4.3-9-11-2.7-25.4,19.8-3.6-.3-1.5,13.7-12.9,1.3,7.6,11h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "cc_gh",
    className: "color8",
    d: "M54.7,155.7l1.5,3.6,4,6.3h2.2c0,0,6.1-3.5,6.1-3.5l-.4-19.7-4.7-1.4-6.6.2-2.1,14.5h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "cc_tg",
    className: "color7",
    d: "M69.7,161.5l3.7-2.2v-14.3c0,0-2.5-3.9-2.5-3.9l-1.5,1.3.3,19h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "cc_bj",
    className: "color5",
    d: "M74.5,159.1h2.9l.2-8.3,3.7-5.4-.2-9.3h-3.3c0,0-5.7,4.4-5.7,4.4l2.4,4.6v14h0,0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ng",
    className: "color2",
    d: "M78.5,158.9l5.4.3,6.5,7.3,3.2.9,2.5-1.2,3.8-.5,1.3-5.3,5.1-3.4,5.6-.3,10.2-18.7-.2-4.2-4.7-3.6-9.4,4.1-12.6-.2-6-3.8-4.3,1-2.2,3.9-.2,11-3.6,5.1-.3,7.8h0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "cc_tn",
    className: "color8",
    d: "M96.8,32.1l7.6-3.1,2.5,1.6v2c0,0-1.1,1.5-1.1,1.5l.2,2.7,1.2.6v4.9l-1.4,2.3.2,1.4,5.1,1.8-4.1,6.4h-1.6c0,0-.3,5.1-.3,5.1l-1.8.3-1.5-1.4.4-5.2-5-4.9-.6-4.2,2.4-1.9-2.1-9.9h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ly",
    className: "color5",
    d: "M103.9,60.6l2.1-.4.6-5h1.1l4.4-7.2,10.8,3.2,3,4.6,10.7,4.9,5.6-2.3-.5-2.3-2.4-2.3.3-1.6,3.9-3.3h7.8l3,4,6.3.9.8,50.8-4.7-.2-28.1-14.6-3,1.7-11.6-2.9-3.1-4.1-4.6-.6-2.3-4.1v-18.9h0,0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "cc_eg",
    className: "color0",
    d: "M161.6,53.8h3.7c0,0,7.2,2.1,7.2,2.1h3.4c0,0,4.2-3.4,4.2-3.4h2l3.6,2h5.3c0,0,2.9,8.2,2.9,8.2l.8,2.7.8,4-1.4,1-2.3-1.2-2.7-8.8-2.4-.2-.2,3,1.6,5.2,12.9,16,.3,6.9-3.8,4.3-35.3-.4-.5-41.2h0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "cc_td",
    className: "color1",
    d: "M121.5,126.7l.2-4.1,6.5-6.4,1.7-15.6-4.4-8.3,3-1.6,29.5,15.4-.2,15.1-5.2,4.4v7.8l3.4,6.6h-6l-9.9,9.8-.3,3h-7.3c0,0,0,1.3,0,1.3l-4.2-.6-2.9-5.4-2.1-1.1.3-1.7,2.7-2.1v-9.7l-3.7-.6-4.5-3.3,3.5-3h0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "cc_sd",
    className: "color3",
    d: "M159.5,105.6l-.2,15.9-5.1,4.4-.2,6.8,3.8,7.8,3.7,1.7-.4,4.5-1.7,1,2.3,2.3,1.3-.5,3.6-6.7,2.7,2.7h5.2l.9,1.4h3.1l4.3-4.2,4.2,2.8,4.8-5.4-1.1-4.1,5.1-.7v6c0,0,3.4,4.7,3.4,4.7l9-19.2v-10.8l6-7.1-11.6-17.1-4.1,4.7-36-.3.4,9.5h-3.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ss",
    className: "color0",
    d: "M195.3,148.7l3.2-1.4-3.9-5.3v-5.3l-2.7.4,1,3.5-5.7,6.6-4.3-2.7-3.7,3.7h-4.5l-.8-1.2h-5.1l-1.8-2.1-3.1,5.7-1.2.4,13.9,14,9.2.5,1.3,2,13.2.2v-3.1s1.2-1.9,1.2-1.9l4.1-.5-5.3-7.8h-4.1s-.8-5.8-.8-5.8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "cc_cm",
    className: "color8",
    d: "M100.9,165.7l4.4,4.1-.3,6.3,24.3-.6,2-2.2-7-7.5-1-2.7,4.4-8.3-3-5.5-2.5-1.4v-2.8l2.9-1.9.2-8.7-2.3-.3v4.6s-10.3,19.1-10.3,19.1l-6.3.3-4.3,2.9-1.3,4.6h0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "cc_er",
    className: "color8",
    d: "M209.5,124.9l-.3-8.1,5.5-6.4,1.5,1.1,2.7,9,12.9,9.6-2.3,2.9-9.4-8.1h-10.4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "cc_dj",
    className: "color3",
    d: "M229.9,134.3l-.8,4.6h5.5c0,0,0-6.9,0-6.9l-2-1.2-2.8,3.5h0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "cc_et",
    className: "color2",
    d: "M199.6,148.4l10-22.3h10c0,0,8.8,7.7,8.8,7.7l-.6,6.3h6.8l.7,3.8,11.1,6.6,6.8.3-13,14-17.8,5.5h-4.4l-7.9-6.7-3.1-1.3-6-8.9h-4c0,0-.5-4-.5-4l3.1-1h0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "cc_so",
    className: "color2",
    d: "M235.8,139.2l5.6,3.8h1.7c0,0,14-4.9,14-4.9l1.6,5.1-1.1,4.3-3,2.4-7.5-.5-10.8-6.6-.4-3.7h0M258.1,137.8l6-2.3,2.1,1.3-.2,5.3-5.6,15.8-30,32.2-3.5-2.4-.2-13.6,4.5-5.2,9.6-3,14.1-14.9,3.7-3.3,1-4.8-1.5-5.2h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "cc_cf",
    className: "color6",
    d: "M125.4,165.3l6.4,6.9,2.5-3.3,4,.2.9-3.2,4-2.5,8.2,5.7,4.8-4.7,18.4.8-17.1-17.7,2.3-1.4.3-3.1-3.9-1.8h-5.7l-9.2,9.1-.3,3.7-7.3-.2-.2,1.6-4.8-.5-4.3,8.1.9,2.2h0Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "cc_gq",
    className: "color3",
    d: "M99.5,170l-.6,2.7,1.9,1,1.8-1.4-.6-2.8-2.5.4h0M105.2,177.3v1.9c0,0,6.2.3,6.2.3v-2.2c0,0-6.2,0-6.2,0h0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ga",
    className: "color0",
    d: "M112.7,177.2l-.2,3.4-7.8-.2-4.8,9.2,11.2,12.2,2.8-2.3v-2.4c0,0-2-.9-2-.9v-1.7l4.3-2.7,3.8,2.9h4.2c0,0,0-14.4,0-14.4l-6.7-.3v-3c0,0-4.8.2-4.8.2h0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "cc_cg",
    className: "color5",
    d: "M119,177v2c0,0,6.5.2,6.5.2l.2,17.1-6-.2-3.5-2.7-2.7,1.5v.8c-.1,0,1.3.7,1.3.7l.4,3.5-3.7,3.2.8,1.7,4.1-3.2h2l.6,1.9,2.6,1.1,8.4-7.1-.2-5.2,1.7-4.2,5.4-4,1.4-13.5h-3.8s-4.4,6.1-4.4,6.1l-11.2.4h0Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ao",
    className: "color6",
    d: "M112.9,205.5l2.4,3.1,3.1-2.9-.9-3h-.8c0,0-3.8,2.9-3.8,2.9h0M115.7,210.3l4.7,17.5v5.5c-.1,0-7,7.4-7,7.4l-1,12,26.5.2,8.6,3.1,7.1-.9-4.1-5.2v-14.8s8.1-.3,8.1-.3v-5.8l-6.6-.3-1.3-13.7h-2.8s-1.5-1.3-1.5-1.3h-1.6c0,0-2.2,4.3-2.2,4.3h-8.4l-1.9-2,.6-2.8-2.3-3.3-14.8.2h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "cc_cd",
    className: "color7",
    d: "M116.8,209l14.2-.2,2.9,4.1v3c-.1,0,1,1,1,1h7.1l2-4h2.9l1.2,1.2h4c0-.1,1.2,13.8,1.2,13.8l6.8.2v1.1l18.4,8.3.9,1.6h3.8l-.4-5.8-6.9-3.3.4-4.4,3-7,6.8-.2-5.9-19.5v-8.3c.1,0,9.4-14.5,9.4-14.5v-2c.1,0-1.3-.8-1.3-.8v-3.9c0,0-1.6-.2-1.6-.2l-1.7-2.2-28-1.3-5.1,5-8.4-5.5-3,1.8-2.1,18.1-5.3,4.1-1.6,3.6.3,5.4-9.6,7.8-2.5-1.2.3,1.5-2.8,2.7h0Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "cc_rw",
    className: "color2",
    d: "M183.5,187.2l3.9,3.6-.2,3.8h-6c0,.1,0-4.1,0-4.1l2.3-3.3h0Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "cc_bi",
    className: "color1",
    d: "M181.3,195.9h5.9c0-.1-1.5,5-1.5,5l-1.5,1.3h-1.8l-1.3-3.5.2-2.8h0Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ug",
    className: "color8",
    d: "M184.2,186.1l4.2,3.9,2.6-1.7,7.1-1.2h1.2c0,.1.5-2.6.5-2.6l4-8.4-3.4-7h-10.9c0,0,0,2.9,0,2.9l1.5,1.4-.2,2.9-6.4,9.6h0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ke",
    className: "color5",
    d: "M201.4,168.8l3.7,7.2-4.4,9.2-.6,2.8,21.9,13.6,6.8-10.7-3.4-2.8v-14.1c0,0,4.2-4.7,4.2-4.7l-6.9,2.3h-5.2c0,0-8.1-6.8-8.1-6.8l-2.6-1.1-4.8.4-.8,1.4v3.3q.1,0,.1,0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "cc_tz",
    className: "color6",
    d: "M201.1,230.6l24.1-2.9-5.4-10.5-.3-10,1.7-4.8-22.9-14.4-7.2,1.2-2.5,1.8-.2,4.2-1.6,5.8-1.7,2-2.4.2,4.6,16,7.5,3.5,5.2.2,1,7.7h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "cc_zm",
    className: "color3",
    d: "M151.5,248.9l4.4,6.1,6.8.4,2.4,1.3h7.1c0,0,6.1-8.5,6.1-8.5l17.1-7.6,1.5-6.7-2-9.6-8.9-5.1-5.9.4-3,6.6v3c0,0,7.1,3.4,7.1,3.4l.4,7.4-6,.3-1.5-2.5-16.7-7.1-.5,5.5-7.9.2-.3,12.5h0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "cc_mw",
    className: "color8",
    d: "M196.4,241.6l4.3,4.5v5.7c0,0,.7,2.4.7,2.4l5.7-6.1-.7-7.8-3-2.3-2.7-13.7-4.7-.2,2.1,9.9-1.7,7.7h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "cc_mz",
    className: "color1",
    d: "M188.1,288.3l3.7,3.1,8.7-5.3,1.4-7.9v-13l14-11.5h2.4c0,0,8.5-8.1,8.5-8.1l-1.3-16.8-22.5,2.8.7,5.1,3.9,3,.9,9.1-7.6,7.4-1.8-4.1.3-5.5-4.4-4.7-10.7,5,10,5.1.3,14.8-6.6,9.8v11.8h0,0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "cc_zw",
    className: "color1",
    d: "M165.4,259.4l12.4,14,9.5,2.4,6.4-10-.5-13.2-10.3-5.3-3.9,1.7-5.8,8.8h-8c0,0,.2,1.6.2,1.6h0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "cc_na",
    className: "color2",
    d: "M126.7,300.2l4.6.3,2.7,2.7h6.4c0,0,1.6-18.2,1.6-18.2v-12l4.1-.8,1.6-12.5,10.5-.3,3.7-3.1-6.3-.2-8.5,1.2-9.1-3.3h-25.7l.7,7.3,8.6,12.6-1.5,6.5v3.4c0,0,6.7,16.4,6.7,16.4h0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "cc_bw",
    className: "color0",
    d: "M143.1,285.5l3,.9-.4,8.5,3,.4,7-6.3,8.4.9,2.2-5.6,10.6-9.7-12.8-14.7-.2-2.4-1.4-.4-3.9,3.6-10.1.2-1.4,12.5-4,.9-.2,11.2h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "cc_sz",
    className: "color3",
    d: "M187.7,289.3l-3.5.6-1.5,4.1,2.6,2.4h3.2l2.7-3.9-3.6-3.2h0Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "cc_ls",
    className: "color6",
    d: "M169.2,305l4.2-3.2h2c0,0,2.4,3.1,2.4,3.1l-.2,3-4,1.5v1.2l-4.4-.2-1.1-3.2,1.2-2h0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "cc_za",
    className: "color8",
    d: "M178.5,275l-10.9,10.1-2.6,6.2-8.6-1.1-7.2,6.4-4.8-.5.4-8.8-1.7-.6-1.2,18h-8.5c0,0-2.5-3.1-2.5-3.1h-3.7s3.4,9.7,3.4,9.7l6.1,5.7-4.3,5.1,2.8,6.3,6.5,2.5,5.2-4.4h14.8c0,0,1.1-1.2,1.1-1.2l6.6-1.2,22.3-22.2v-7c0,0-2.5,3.1-2.5,3.1h-3.6l-4.3-3.6,2.2-5.5,3.8-.8-.3-11.3-8.4-1.9h0ZM173.3,300.5h2.1c0,0,3.4,3.6,3.4,3.6v4.2c0,0-4.1,2-4.1,2l-.2,1.4h-6c0,0-1.9-4.5-1.9-4.5l1.7-3.3,5-3.4h0Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "cc_mg",
    className: "color4",
    d: "M258.6,232.7l-2.9,7-5,8.9-8.8.6-3.8,4.4.6,13.5-5.5,6.3.6,10.8,4.6,5.3,5.5-.6,5.5-4-1.3-6.3,12.6-21.8-2.5-2.7,2.5-5.3,2.7.8.8-2.1-2.5-10.8-1.5-4.4-1.7.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfrica);
export default __webpack_public_path__ + "static/media/africa.66b986aa230a1de72715d78246cc5503.svg";
export { ForwardRef as ReactComponent };